function img($log, $rootScope) {
    const fallbackMediaSrc = require("../../assets/icons/ic_broken_image.svg");

    return {
        restrict: "E",
        link: (scope, element, attrs)  => {
            element.on("error", () => {
                $rootScope.$broadcast("img.onerror", {img: element});

                $log.warn(`Error while loading ${attrs.src}`);
                if (attrs.src !== fallbackMediaSrc) {
                    attrs.$set(
                        "src",
                        fallbackMediaSrc
                    );
                }
            });
        }
    };
}

img.$inject = ["$log", "$rootScope"];

angular
    .module("thor.core.img.directive", [])
    .directive("img", img);
